import React from "react";
import PropTypes from "prop-types";
import {
  Input,
  Select,
  InputNumber,
  Switch,
  DatePicker,
  Modal,
  message,
} from "antd";
import ScheduleWeekdayElement from "../ReportList/ScheduleElementsObj/ScheduleWeekdayElement";
import { ScheduleElementObj } from "../ReportList/ScheduleElements";
import {
  ASNEEDED,
  REPORT_TYPES,
  SOURCELIST,
  getScheduleTriggerTypes,
  getFileExtensionsBySignatureType,
} from "../../utils/report";
// import { isMoment } from "moment";

const { confirm } = Modal;
const { Option } = Select;

const sourceTypeOptions = SOURCELIST.map((source) => (
  <Option value={source} key={source}>
    {source}
  </Option>
));

const labelSet = {
  ReportName: "Report Name",
  PMSReportName: "PMS Report Name",
  emailSubjects: "Email Subjects",
  filenames: "File Name",
  FileMappingName: "File Mapping Name",
  FileExtension: "File Extension",
  report_name_matching_condition: "Report Name Matching Condition",
  activation_date: "Activation Date",
  deactivation_date: "Deactivation Date",
  signature_activation_date: "Signature Activation Date",
  signature_deactivation_date: "Signature Deactivation Date",
};

const showConfirm = () => {
  return new Promise((resolve) => {
    confirm({
      // title: 'Do you Want to delete these items?',
      // icon: <ExclamationCircleOutlined />,
      content:
        "The report is QC ignored, do you still want to show it in Compliance?",
      onOk() {
        resolve(true);
      },
      onCancel() {
        resolve(false);
      },
      icon: null,
    });
  });
};

export const QC_ComplianceOnChange = (onChange, dataIndex, formInputPath, getValues, setValue) => {
  return async (e) => {
    let getValueKey = "";
    onChange(e);
    switch (dataIndex) {
      case "QC_IgnoredReport":
        getValueKey = `${formInputPath}ComplianceEnabled`;
        break;
      case "ComplianceEnabled":
        getValueKey = `${formInputPath}QC_IgnoredReport`;
        break;
      default:
    }
    if (e && getValues(getValueKey)) {
      const val = await showConfirm();
      if (!val) {
        setValue(`${formInputPath}ComplianceEnabled`, false);
      }
    }
  };
};

const generateInputElement = (
  dataIndex,
  {
    errors,
    field,
    watch,
    setValue,
    reportCategories = [],
    getValues,
    resetField,
    formInputPath,
    documentTypes = [],
    inputProps,
  },
) => {
  const fileExtensionOptions = (reportExtensions) =>
    reportExtensions.map((extension) => ({
      label: extension,
      value: extension,
    }));

  const { onChange, onBlur, value, ref } = field;
  let errorParentElement = errors;
  const errorPathArray = formInputPath
    .split(".")
    .filter((element) => element.length > 0);
  for (let index = 0; index < errorPathArray.length; index++) {
    const subElementPath = errorPathArray[index];
    if (errorParentElement?.[subElementPath]) {
      errorParentElement = errorParentElement?.[subElementPath];
    }
  }
  const errorStatus = errorParentElement?.[dataIndex] ? "error" : "";

  switch (dataIndex) {
    case "report_category":
      return (
        <Select
          status={errorStatus ? "error" : ""}
          placeholder="Report Category"
          value={value}
          mode="multiple"
          onChange={onChange}
          style={{ width: "100%" }}
          allowClear
          showSearch
          optionFilterProp="children"
        >
          {reportCategories.map((category) => {
            return (
              <Option value={category._id} key={category._id}>
                {category.name}
              </Option>
            );
          })}
        </Select>
      );
    case "signature_type":
      return (
        <Select
          status={errorStatus ? "error" : ""}
          placeholder="Report Type"
          value={value}
          onBlur={onBlur}
          onChange={(e) => {
            if (e === "1") {
              setValue(`${formInputPath}ReportOrder`, null);
            }
            setValue(`${formInputPath}SignatureMandatory`, e === "2");
            onChange(e);
          }}
          style={{ width: "100%" }}
        >
          <Option value="1">Non-Signature</Option>
          <Option value="2">Signature Required</Option>
        </Select>
      );
    case "ReportOrder":
      return (
        <InputNumber
          status={errorStatus ? "error" : ""}
          placeholder="Report Order"
          disabled={watch(`${formInputPath}signature_type`) === "1"}
          value={value}
          style={{ width: "100%" }}
          min={1}
          step={1}
          // ref={ref}
          onChange={onChange}
          onBlur={onBlur}
        />
      );
    case "schedule_trigger_type":
      return (
        <Select
          status={errorStatus ? "error" : ""}
          value={value}
          style={{ width: "100%" }}
          onChange={(e) => {
            onChange(e);
            setValue(`${formInputPath}schedule_weekday`, undefined);
            setValue(`${formInputPath}schedule_trigger_data`, undefined);
          }}
          placeholder="Schedule Type"
          options={getScheduleTriggerTypes(
            watch(`${formInputPath}shedule_type`),
          )}
        />
      );
    case "schedule_weekday":
      return (
        <ScheduleWeekdayElement
          record={{
            shedule_type: watch(`${formInputPath}shedule_type`),
            schedule_trigger_type: watch(
              `${formInputPath}schedule_trigger_type`,
            ),
            schedule_weekday: watch(`${formInputPath}schedule_weekday`),
          }}
          updateField={onChange}
          errorStatus={errorStatus}
        />
      );
    case "schedule_trigger_data":
      return (
        <ScheduleElementObj
          record={{
            shedule_type: watch(`${formInputPath}shedule_type`),
            schedule_trigger_type: watch(
              `${formInputPath}schedule_trigger_type`,
            ),
            schedule_trigger_data: watch(
              `${formInputPath}schedule_trigger_data`,
            ),
            schedule_weekday: watch(`${formInputPath}schedule_weekday`),
          }}
          // record={getValues(`${formInputPath}`)}
          updateField={onChange}
          invalidField={errorStatus}
        />
      );
    case "schedule_months":
      return (
        <Select
          placeholder="Please Select Month"
          mode="multiple"
          value={value}
          onChange={onChange}
          style={{ width: "100%" }}
        >
          <Option value="January">January</Option>
          <Option value="February">February</Option>
          <Option value="March">March</Option>
          <Option value="April">April</Option>
          <Option value="May">May</Option>
          <Option value="June">June</Option>
          <Option value="July">July</Option>
          <Option value="August">August</Option>
          <Option value="September">September</Option>
          <Option value="October">October</Option>
          <Option value="November">November</Option>
          <Option value="December">December</Option>
        </Select>
      );
    case "business_date":
      return (
        <Select
          status={errorStatus ? "error" : ""}
          placeholder="Business Date"
          onChange={onChange}
          style={{ width: "100%" }}
          value={value}
          onBlur={onBlur}
          {...inputProps}
        >
          <Option value="0">Current Date</Option>
          <Option value="-1">Current Date - 1</Option>
        </Select>
      );
    case "FileExtension":
      return (
        <Select
          value={value}
          mode={
            getValues(`${formInputPath}signature_type`) === "2"
              ? "multiple"
              : "tags"
          }
          placeholder={labelSet[dataIndex]}
          onChange={onChange}
          onBlur={onBlur}
          disabled={
            dataIndex === "emailSubjects" &&
            watch(`${formInputPath}SourceType`) !== "Email"
          }
          style={{ width: "100%" }}
          options={fileExtensionOptions(
            getFileExtensionsBySignatureType(
              getValues(`${formInputPath}signature_type`),
            ),
          )}
        />
      );
    case "emailSubjects":
    case "filenames":
      return (
        <Select
          value={value}
          mode="tags"
          placeholder={labelSet[dataIndex]}
          onChange={onChange}
          onBlur={onBlur}
          disabled={
            dataIndex === "emailSubjects" &&
            watch(`${formInputPath}SourceType`) !== "Email"
          }
          style={{ width: "100%" }}
        />
      );
    case "SignatureMandatory":
      return (
        <Switch
          checked={value}
          onChange={onChange}
          {...(watch(`${formInputPath}signature_type`) == 1
            ? { disabled: true }
            : {})}
        />
      );
    case "QC_IgnoredReport":
    case "ComplianceEnabled":
      return (
        <Switch
          checked={value}
          onChange={QC_ComplianceOnChange(
            onChange,
            dataIndex,
            formInputPath,
            getValues,
            setValue,
          )}
          {...(dataIndex === "ComplianceEnabled" && // may need to re-check, input can be disabled while value set to true
          watch(`${formInputPath}shedule_type`) == ASNEEDED
            ? { disabled: true }
            : {})}
        />
      );
    case "activation_date":
      return (
        <DatePicker
          allowClear={false}
          placeholder={labelSet[dataIndex]}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          {...inputProps}
        />
      );
    case "deactivation_date":
      return (
        <DatePicker
          placeholder={labelSet[dataIndex]}
          status={errorStatus ? "error" : ""}
          // disabledDate={(_currentDate) =>
          //   _currentDate < getValues(`${formInputPath}activation_date`)
          // }
          value={value}
          onChange={(e) => {
            // if (e && e < getValues(`${formInputPath}activation_date`)) {
            //   message.error("Invalid Deactivation Date");
            //   resetField(`${formInputPath}deactivation_date`);
            // } else {
              onChange(e);
            // }
          }}
          onBlur={onBlur}
          {...inputProps}
        />
      );
    case "signature_activation_date":
      return (
        <DatePicker
          placeholder={labelSet[dataIndex]}
          status={errorStatus ? "error" : ""}
          // disabledDate={(_currentDate) =>
          //   _currentDate < getValues(`${formInputPath}activation_date`) ||
          //   (getValues(`${formInputPath}deactivation_date`) &&
          //     _currentDate > getValues(`${formInputPath}deactivation_date`))
          // }
          value={value}
          disabled={watch(`${formInputPath}signature_type`) !== "2"}
          onChange={(e) => {
            // if (e && e < getValues(`${formInputPath}activation_date`)) {
            //   message.error(
            //     "Signature Activation Date Should Be After The Report Activation Date",
            //   );
            //   resetField(`${formInputPath}signature_activation_date`);
            // } else if (e && 
            //   getValues(`${formInputPath}deactivation_date`) &&
            //   e > getValues(`${formInputPath}deactivation_date`)
            // ) {
            //   message.error(
            //     "Signature activation date should be before the report deactivation date",
            //   );
            //   resetField(`${formInputPath}signature_activation_date`);
            // } else {
              onChange(e);
            // }
          }}
          onBlur={onBlur}
          {...inputProps}
        />
      );
    case "signature_deactivation_date":
      return (
        <DatePicker
          placeholder={labelSet[dataIndex]}
          status={errorStatus ? "error" : ""}
          // disabledDate={(_currentDate) =>
          //   _currentDate < getValues(`${formInputPath}activation_date`) ||
          //   (getValues(`${formInputPath}signature_activation_date`) &&
          //     _currentDate < getValues(`${formInputPath}signature_activation_date`)) ||
          //   (getValues(`${formInputPath}deactivation_date`) &&
          //     _currentDate > getValues(`${formInputPath}deactivation_date`))
          // }
          value={value}
          disabled={
            // !isMoment(watch(`${formInputPath}signature_activation_date`)) ||
            watch(`${formInputPath}signature_type`) !== "2"
          }
          onChange={(e) => {
            // if (e && e < getValues(`${formInputPath}activation_date`)) {
            //   message.error(
            //     "Signature Deactivation Date Should Be After The Report Activation Date",
            //   );
            //   resetField(`${formInputPath}signature_deactivation_date`);
            // } else if (
            //   e &&
            //   getValues(`${formInputPath}signature_activation_date`) &&
            //   e < getValues(`${formInputPath}signature_activation_date`)
            // ) {
            //   message.error(
            //     "Signature Deactivation Date Should Be After The Signature Activation Date",
            //   );
            //   resetField(`${formInputPath}signature_deactivation_date`);
            // } else if (
            //   e &&
            //   getValues(`${formInputPath}deactivation_date`) &&
            //   e > getValues(`${formInputPath}deactivation_date`)
            // ) {
            //   message.error(
            //     "Signature Deactivation Date should Be Before Or The Same As The Report Deactivation Date",
            //   );
            //   resetField(`${formInputPath}signature_deactivation_date`);
            // } else {
            onChange(e);
            // }
          }}
          onBlur={onBlur}
          {...inputProps}
        />
      );
    case "smart_scan_type":
      return (
        <Select
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder="Smart Scan"
          style={{ width: "100%" }}
          {...inputProps}
        >
          <Option value={2}>Parent</Option>
          <Option value={1}>Yes</Option>
          <Option value={0}>No</Option>
        </Select>
      );
    case "enable_redaction":
    case "export_flat_files":
    case "file_extension_mapping":
      return (
        <Switch defaultChecked={value} checked={value} onChange={onChange} />
      );
    case "split_by_sub_header":
      return (
        <Select
          style={{ width: "100%" }}
          value={value}
          onChange={onChange}
          placeholder="Split Reports By Sub Header Type"
        >
          <Option value={2}>Parent</Option>
          <Option value={1}>Yes</Option>
          <Option value={0}>No</Option>
        </Select>
      );
    case "document_type":
      return (
        <Select
          placeholder="Please Select Document Type"
          mode="multiple"
          value={value}
          onChange={onChange}
          style={{ width: "100%" }}
          options={documentTypes.map((documentType) => {
            return {
              value: documentType._id,
              label: `${documentType.documentTitle}_${documentType.migDocumentTypeId}`,
            };
          })}
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
        />
      );
    case "SourceType":
      return (
        <Select
          status={errorStatus ? "error" : ""}
          placeholder="Source Type"
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          style={{ width: "100%" }}
          {...inputProps}
        >
          {sourceTypeOptions}
        </Select>
      );
    case "report_name_matching_condition":
      return (
        <Select
          placeholder="Report Name Matching Condition"
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          style={{ width: "100%" }}
          {...inputProps}
        >
          <Option value="Exact">Exact</Option>
          <Option value="Contains">Contains</Option>
          <Option value="Regex">Regex</Option>
        </Select>
      );
    case "FileMappingName":
    case "PMSReportName":
    case "ReportName":
      return (
        <Input
          status={errorStatus ? "error" : ""}
          ref={ref}
          placeholder={labelSet[dataIndex]}
          onBlur={onBlur}
          value={value}
          onChange={onChange}
        />
      );
    case "shedule_type":
      // TODO: unset defaultValue. instead set the value at form Element.
      return (
        <Select onChange={onChange} value={value}>
          {REPORT_TYPES.map((type) => (
            <Option key={type.ReportType} value={type.ReportType}>
              {type.label}
            </Option>
          ))}
        </Select>
      );
    case "mydocs_report_type":
      return (
        <Select
          onChange={onChange}
          value={value}
          placeholder="myDocs Report Type"
          style={{ width: "100%" }}
        >
          <Option value="System">System</Option>
          <Option value="Bulk">Bulk</Option>
          <Option value="Batch">Batch</Option>
        </Select>
      );
    default:
      return null;
  }
};

const InputElement = ({
  field,
  resetField,
  watch,
  setValue,
  getValues,
  reportCategories,
  errors,
  dataIndex,
  formInputPath,
  documentTypes,
  inputProps,
}) => {
  return generateInputElement(dataIndex, {
    errors,
    field,
    watch,
    setValue,
    reportCategories,
    getValues,
    resetField,
    formInputPath,
    documentTypes,
    inputProps,
  });
};

InputElement.defaultProps = {
  formInputPath: "",
  inputProps: {},
};

InputElement.propTypes = {
  dataIndex: PropTypes.string.isRequired,
  formInputPath: PropTypes.string.isRequired,
};

export default InputElement;
